const prodConfig = {
    prodOrDev: 'prod',
    // apiHost: 'https://mp-dev.bobiton.com/',
    // wsUrl: 'wss://mpp-dev.bobiton.com/wsDataScreen/ws',
    apiHost: 'https://mp.bobiton.com/',
    wsUrl: 'wss://mpp.bobiton.com/wsDataScreen/ws',
    title: '视频号推客',
};

const devConfig = {
    prodOrDev: 'dev',
    apiHost: 'https://mp-dev.bobiton.com/',
    wsUrl: 'wss://mpp-dev.bobiton.com/wsDataScreen/ws',
    // apiHost: 'https://mp.bobiton.com/',
    // wsUrl: 'wss://mpp.bobiton.com/wsDataScreen/ws',
    title: '视频号推客',
};

const config = process.env.NODE_ENV === 'development' ? devConfig : prodConfig;

export default config;
